"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TABLET_MIN_WIDTH = exports.TABLET_MAX_WIDTH = exports.DESKTOP_MIN_WIDTH = exports.MOBILE_MAX_WIDTH = void 0;
exports.MOBILE_MAX_WIDTH = 479;
exports.DESKTOP_MIN_WIDTH = 480;
exports.TABLET_MAX_WIDTH = 768;
exports.TABLET_MIN_WIDTH = 480;
//# sourceMappingURL=media-constants.js.map